import {
	getNumber,
	getString,
	getArray,
} from "../../../../../utils/mappersUtils/object";

/**
 * For a single "template" object, produce an array of translation rows:
 * Usually just 1 row: the template row.
 * shape: { id, baseTranslations, translations: { [lang]: { item?: { key, value } } } }
 */
export function checklistTemplateMapper(templateObj) {
	const id = getNumber(templateObj, "id", 0);
	const baseDesc = getString(templateObj, "description", "");
	const templateDetails = getArray(templateObj, "templateDetails");

	const translations = {};
	templateDetails.forEach((td) => {
		const lang = getString(td, "language", "");
		if (!lang) return;

		translations[lang] = {
			item: {
				key: "description",
				value: getString(td, "description", ""),
				maxLength: 64,
			},
		};
	});

	return [
		{
			id,
			type: "TEMPLATE",
			baseTranslations: {
				description: baseDesc,
			},
			translations,
			fieldLimits: {
				description: 64,
			},
		},
	];
}
